import React from "react";

interface IProps
{
    url: string;
    width?: number;
    height?: number;
    alt?: string;
    caption?: string;
}

const ImageView = (props: IProps) =>
{
    return <>
        <figure
            itemProp="associatedMedia"
            itemType="http://schema.org/ImageObject"
        >
            <img
                src={props.url}
                width={props.width}
                height={props.height}
                alt={props.alt}
                itemProp="thumbnail"
                className={"lazyload" + (props.caption ? " " : "has-caption")}
            />
            {!!props.caption &&
                <figcaption
                    itemProp="caption description"
                >
                    {props.caption}
                </figcaption>
            }

        </figure>
    </>
}
export default ImageView;